export const FETCH_SKILLS_REQUEST = "FETCH_SKILLS_REQUEST";
export const FETCH_SKILLS_SUCCESS = "FETCH_SKILLS_SUCCESS";
export const FETCH_SKILLS_FAILURE = "FETCH_SKILLS_FAILURE";

export const SAVE_SKILL_REQUEST = "SAVE_SKILL_REQUEST";
export const SAVE_SKILL_SUCCESS = "SAVE_SKILL_SUCCESS";
export const SAVE_SKILL_FAILURE = "SAVE_SKILL_FAILURE";

export const DELETE_SKILL_REQUEST = "DELETE_SKILL_REQUEST";
export const DELETE_SKILL_SUCCESS = "DELETE_SKILL_SUCCESS";
export const DELETE_SKILL_FAILURE = "DELETE_SKILL_FAILURE";

export const GET_EMPLOYEE_SKILLS_REQUEST = "GET_EMPLOYEE_SKILLS_REQUEST";
export const GET_EMPLOYEE_SKILLS_SUCCESS = "GET_EMPLOYEE_SKILLS_SUCCESS";
export const GET_EMPLOYEE_SKILLS_FAILURE = "GET_EMPLOYEE_SKILLS_FAILURE";

export const SAVE_EMPLOYEE_SKILLS_REQUEST = "SAVE_EMPLOYEE_SKILLS_REQUEST";
export const SAVE_EMPLOYEE_SKILLS_SUCCESS = "SAVE_EMPLOYEE_SKILLS_SUCCESS";
export const SAVE_EMPLOYEE_SKILLS_FAILURE = "SAVE_EMPLOYEE_SKILLS_FAILURE";
